/* eslint-disable react/prop-types */
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useField, useFormikContext } from 'formik';
// prop-types is a library for typechecking of props

const SelectField = ({
  label,
  options,
  sx,
  helperText,
  isRequired = false,
  ...props
}) => {
  const [field, helpers] = useField(props);
  const { getFieldMeta } = useFormikContext();
  const meta = getFieldMeta(field.name);

  return (
    <FormControl fullWidth error={Boolean(meta.touched && meta.error)}>
      <InputLabel htmlFor={`outlined-select-${field.name}`}>
        {label} {isRequired ? '*' : ''}
      </InputLabel>
      <Select
        labelId={`outlined-adornment-${field.name}`}
        label={`${label} ${isRequired ? '*' : ''}`}
        MenuProps={{
          style: {
            maxHeight: 300,
          },
        }}
        {...field}
        {...props}
        value={field.value ?? ''}
      >
        {options?.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta?.error && (
        <FormHelperText error id={`standard-helper-${field.name}`}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectField;
